var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tags.length
    ? _c(
        "div",
        { staticClass: "modpack--tags" },
        _vm._l(
          _vm.tagList.sort(function (a, b) {
            return a.rank > b.rank ? 1 : -1
          }),
          function (tag) {
            return _c(
              "div",
              {
                key: tag.slug,
                staticClass: "modpack--tag",
                class: tag.css_classes,
              },
              [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _vm.i18n.t(
                        tag.translation_key.namespace +
                          ":" +
                          tag.translation_key.key
                      )
                    ) +
                    "\n  "
                ),
              ]
            )
          }
        ),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }